import { StyledBar } from './Bar.styles';

export type BarProps = {
  fixedWidth?: boolean;
  percentageWidth?: number;
  height: number;
}

export const Bar = ({
  percentageWidth,
  height,
  ...props
}: BarProps) => (
  <StyledBar
    fixedWidth
    percentageWidth={percentageWidth}
    height={height}
    {...props}
  />
);
